var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./Content", "../TrancoderInfo"], function (require, exports, Content_1, TrancoderInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Asset = (function (_super) {
        __extends(Asset, _super);
        function Asset() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Type = Content_1.ContentTypes.Asset;
            _this.Items = [];
            _this.AssetType = Content_1.AssetTypes.Undefined;
            _this.TranscoderInfo = new TrancoderInfo_1.TranscoderInfo();
            _this.Thumbnail = "";
            return _this;
        }
        Object.defineProperty(Asset.prototype, "IsVideo", {
            get: function () { return this.AssetType == Content_1.AssetTypes.Video ? true : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Asset.prototype, "IsImage", {
            get: function () { return this.AssetType == Content_1.AssetTypes.Image ? true : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Asset.prototype, "IsWebSite", {
            get: function () { return this.AssetType == Content_1.AssetTypes.Website ? true : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Asset.prototype, "IsFreeText", {
            get: function () { return this.AssetType == Content_1.AssetTypes.FreeText ? true : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Asset.prototype, "IsStream", {
            get: function () { return this.AssetType == Content_1.AssetTypes.Stream ? true : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Asset.prototype, "IsTVChannel", {
            get: function () { return this.AssetType == Content_1.AssetTypes.TVChannel ? true : false; },
            enumerable: true,
            configurable: true
        });
        return Asset;
    }(Content_1.Content));
    exports.Asset = Asset;
});
//# sourceMappingURL=Asset.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Content/Asset.js
// module id = 155
// module chunks = 0